import { PUBLISHED_ } from '../constants';
const buildAdminHref = ({
  itemEntity,
  itemId
}) => {
  if (!itemEntity || !itemId || !process.env.BLAZE_ADMIN_URL) return '/';
  const updatedItemEntity = itemEntity.replace(PUBLISHED_, '');
  return `${process.env.BLAZE_ADMIN_URL}/data-listing/${updatedItemEntity}/update/${itemId}`;
};
export default buildAdminHref;
//# sourceMappingURL=build-admin-href.js.map